export const API_AUTH = {
  PING: '/ping',
  TOKEN: '/oauth2/token',
  AUTHORIZE: '/oauth2/authorize?',
  LOGOUT: '/logout?',
  GRANT_TYPE: 'authorization_code',
  LOGIN: '/login?',
};
